import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from "../layouts/Layout.vue";
import Login from "../views/Login.vue";

Vue.use(VueRouter)

const routes = [
  {
    path: "/login",
    name: "Login",
    component: Login,
  },
  {
    path: "/receipt/:id",
    name: "receipt",
    component: () => import('../views/treasury/print/Receipt.vue')
  },
  {
    path: "/invoice-print/:id",
    name: "invoicePrint",
    component: () => import('../views/invoices/print/Index.vue')
  }, 
    {
    path: "/invoicesAnalysis-print/:id",
    name: "invoiceAnalysisPrint",
    component: () => import('../views/invoicesAnalysis/print/Index.vue')
  }, 
    {
    path: "/prescription-print/:id",
    name: "prescriptionPrint",
    component: () => import('../views/doctorPrescriptions/print/Index.vue')
  },  
  {
    path: "/workDay-print/:type",
    name: "workDayPrint",
    component: () => import('../views/workDaysClosing/print/Receipt.vue')
  },
   {
    path: "/instructions-print/:id",
    name: "instructionsPrint",
    component: () => import('../views/settings/instructions/print/Index.vue')
  },
  {
    path: '/',
    name: 'Layout',
    component: Layout,
    redirect: "dashboard",
    children: [
      {
        path: 'dashboard',
        name: 'dashboard',
        component: () => import('../views/dashboard/Index.vue')
      },
       {
        path: 'workDaysClosing',
        name: 'workDaysClosing',
        component: () => import('../views/workDaysClosing/Index.vue')
      },    {
        path: 'bookPatients',
        name: 'bookPatients',
        component: () => import('../views/bookPatient/Index.vue')
      },
      {
        path: 'doctorsAppointments',
        name: 'doctorsAppointments',
        component: () => import('../views/doctorsAppointments/Index.vue')
      },{
        path: 'paymentAccounts',
        name: 'paymentAccounts',
        component: () => import('../views/settings/paymentAccounts/Index.vue')
      },
      {
        path: 'patients', name: 'Patients',
        component: () => import('../views/patients/Index.vue')
      },
      {
        path: 'patientsProcedures', name: 'patientsProcedures',
        component: () => import('../views/patientsProcedures/Index.vue')
      },    {
        path: 'pharmacy', name: 'pharmacy',
        component: () => import('../views/pharmacy/Index.vue')
      }, 
      {
        path: 'treasury', name: 'treasury',
        component: () => import('../views/treasury/Index.vue')
      },
      {
        path: '/doctorPrescriptions', name: 'doctorPrescriptions',
        component: () => import('../views/doctorPrescriptions/Index.vue')
      },
      {
        path: '/appointments', name: 'Appointments',
        component: () => import('../views/appointments/Index.vue')
      },
      {
        path: 'employees', name: 'employees',
        component: () => import('../views/employees/Index.vue')
      }, {
        path: 'users', name: 'users',
        component: () => import('../views/users/Index.vue')
      },
      {
        path: 'doctorsAppointments', name: 'DoctorsAppointments',
        component: () => import('../views/doctorsAppointments/Index.vue')
      },
      {
        path: 'dispensingMedications', name: 'DispensingMedications',
        component: () => import('../views/dispensingMedications/Index.vue')
      },
      {
        path: 'stock', name: 'Stock',
        component: () => import('../views/stock/Index.vue')
      },
      {
        path: 'stockTypes', name: 'stockTypes',
        component: () => import('../views/stockTypes/Index.vue')
      },
      {
        path: 'stores', name: 'stores',
        component: () => import('../views/stores/Index.vue')
      },      {
        path: 'invoices', name: 'invoices',
        component: () => import('../views/invoices/Index.vue')
      },  
        {
        path: 'invoicesAnalysis', name: 'invoicesAnalysis',
        component: () => import('../views/invoicesAnalysis/Index.vue')
      },
      {
        path: 'departments', name: 'departments',
        component: () => import('../views/settings/departments/Index.vue')
      },  {
        path: 'doctorsStock', name: 'doctorsStock',
        component: () => import('../views/settings/doctorsStock/Index.vue')
      },
      {
        path: 'specializations', name: 'specializations',
        component: () => import('../views/settings/specializations/Index.vue')
      }, {
        path: 'rooms', name: 'rooms',
        component: () => import('../views/settings/rooms/Index.vue')
      },
      {
        path: 'doctors', name: 'doctors',
        component: () => import('../views/settings/doctors/Index.vue')
      },
      {
        path: 'doctorsSchedule', name: 'doctorsSchedule',
        component: () => import('../views/settings/doctorsSchedule/Index.vue')
      },
      {
        path: 'reviewsReasons', name: 'reviewsReasons',
        component: () => import('../views/settings/reviewsReasons/Index.vue')
      },
      {
        path: 'services', name: 'Services',
        component: () => import('../views/settings/services/Index.vue')
      },   {
        path: 'analysis', name: 'analysis',
        component: () => import('../views/settings/analysis/Index.vue')
      }, {
        path: 'instructions', name: 'instructions',
        component: () => import('../views/settings/instructions/Index.vue')
      },
      // inventoryManagement
      {
        path: 'medicines', name: 'medicines',
        component: () => import('../views/inventoryManagement/medicines/Index.vue')
      },
      {
        path: 'inventory', name: 'inventory',
        component: () => import('../views/inventoryManagement/inventory/Index.vue')
      },
      {
        path: 'purchaseOrders', name: 'purchaseOrders',
        component: () => import('../views/inventoryManagement/purchaseOrders/Index.vue')
      },  
      {
        path: 'suppliers', name: 'suppliers',
        component: () => import('../views/inventoryManagement/suppliers/Index.vue')
      },  
      {
        path: 'stockTransfers', name: 'stockTransfers',
        component: () => import('../views/inventoryManagement/stockTransfers/Index.vue')
      },  
       {
        path: 'dispenseRequests', name: 'dispenseRequests',
        component: () => import('../views/inventoryManagement/dispenseRequests/Index.vue')
      },
      //---------------------------- report --------------------------------------//
          {
        path: 'salaryDoctorsReport', name: 'salaryDoctorsReport',
        component: () => import('../views/reports/salaryDoctors/Index.vue')
      },
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
